// removed by extract-text-webpack-plugin
module.exports = {"input":"Input-module__input___V1t6I","input__block":"Input-module__input__block___3Ov0G","input__relative":"Input-module__input__relative___1KYaP","input__withIcon":"Input-module__input__withIcon___2G2wy","icon":"Input-module__icon___2TaNV"};


//////////////////
// WEBPACK FOOTER
// ./src/app/components/UI/Input/Input.module.css
// module id = 260
// module chunks = 0